//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PredictedPeakFlow',
  data () {
    return {
      defaultJson:{
        "Height": "身高",
        "Age": "年龄",
        "Predicted PEF": "PEF 预测值",
        "% predicted": "预测值百分比",
        "Measured PEF": "PEF 测定值"
      },
      form: {
        gender:'1',
        age:'',
        height:'',

      },
      measuredPEF:'',
      percentage:'--',
      hasScore: false,
      disabled: false,
      dataList2: [
        {value: '1', name: '男'},
        {value: '0', name: '女'}
      ],
      res2:'--'
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    /** 计算热 res2 */
    calculationRes2(result, measuredPEF){
      console.log(result, measuredPEF,'result, measuredPEF')
      let self = this
       console.log('measuredPEF--5')
      if (measuredPEF &&measuredPEF!='---' && result && result !=='--') {
        let currentTransporttime =Number(measuredPEF)
        let currentresult =Number(result)
        let res = Math.round(currentTransporttime*100/currentresult)
        self.res2 = String(res)
        console.log(self.res2,'measuredPEF--7')
      } else {
        console.log('measuredPEF--6')
        self.res2 ='--'
      }

    }
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        self.res2='--'
        return '--'
      } else {
        console.log(form)
        // gender.isMale ? (e^((0.544*ln(age))-(0.0151*age)-(74.7/height)+5.48)) : (e^((0.376*ln(age))-(0.0120*age)-(58.8/height)+5.63))
        //  form.
        let result =form.gender=='1' ? (Math.pow(Math.E,(0.544*Math.log(form.age)) -(0.0151*form.age)-(74.7/form.height)+5.48)) : (Math.pow(Math.E, (0.376*Math.log(form.age))-(0.0120*form.age)-(58.8/form.height)+5.63))
        self.calculationRes2(result, self.measuredPEF)
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  },
  watch: {
    measuredPEF(newValue, oldValue) {
      let self = this
      self.calculationRes2(self.score, newValue)
    }
  },

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/PredictedPeakFlow.vue